module.exports = __webpack_public_path__ + "static/media/19-14.5bde1a21.mp3";